import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Lector } from "./lector";
import { EstatusCargaDescarga } from "./status";
import { CargaZEGuiasEdit } from "./multiselector/edit";
import { GuiasPreviasCarga } from "./guiasanterioresmodal";

const ImprimirAcusesButton = kea.defaultProps(kea.Button, { children: "Imprimir acuses internos", iconClass: fa("print") });
const ImprimirManifiesto = kea.defaultProps(kea.Button, { children: "Imprimir manifiesto de carga", iconClass: fa("list-ol") });
const VerGuiasIncluidasButton = kea.defaultProps(kea.Button, { children: "Ver guías anteriormente incluidas", iconClass: fa("eye"), style: "success" });

type Entity = models.CargaZEDto;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class CargaZEForm extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    value = (x: Props) => x.value;
    idCarga = createSelectorRx(this.value, value => value.IdRegistro);
    idChoferZE = createSelectorRx(this.value, value => value.IdChoferZE);
    idVehiculo = createSelectorRx(this.value, value => value.IdVehiculoZE);

    foliosGuiasEnVehiculo = createSelectorRx(this.idVehiculo, this.idCarga, (idVehiculo, idCarga) => observeResource(resources.CargaZE.FoliosGuiasEnVehiculoDistintaCarga, idVehiculo, idCarga));
    avisoEntregasNoLiberadas = createSelectorRx(this.idChoferZE, (idChoferZE) => observeResource(resources.CargaZE.ObtenerAvisoEntregasNoLiberadas, idChoferZE));
    vehiculoTieneGuiasDeDistintasCargas = createSelectorRx(this.foliosGuiasEnVehiculo, foliosGuiasEnVehiculo => foliosGuiasEnVehiculo.length > 0);

    get rules(): validation.Rules<Entity> {
        return {
            IdChoferZE: validation.required,
            IdVehiculoZE: validation.required
        };
    }

    private onSeleccionarGuias = async () => {
        var guiasSeleccionadas = this.props.value.IdGuiasIncluidas || [];
        const result = await this.modals.showModal(CargaZEGuiasEdit, guiasSeleccionadas, []);
        if (result.result) {
            var idCargaZE = this.props.value.IdRegistro;
            await resources.CargaZE.IncluirGuiasSeleccionadas(result.value, idCargaZE);
        }
    }

    private onVerGuiasEnVehículo = async () => {
        await this.modals.showModal(GuiasPreviasCarga, undefined, this.props.value);
    }

    private onGenerarAcuses = async () => {
        const value = this.props.value;
        const data = await resources.CargaZE.ObtenerAcusesInternos(value.IdRegistro);
        await kea.printPdf(data);
    }

    private onImprimirManifiesto = async () => {
        if (await kea.yesno("¿Obtener manifiesto de este proceso de carga de zona extendida?")) {
            const params: models.ParametrosReporteManifiestoChoferZE = { IdCargaZE: this.props.value.IdRegistro };
            var manifiestoPDF = await resources.CargaZE.ObtenerManifiestoChofer(params);
            kea.download(kea.base64ToBlob(manifiestoPDF, 'application/pdf'), "Manifiesto de carga de zona extendida.pdf");
        }
    }

    render() {
        const { value, onGuardar, nuevo } = this.props;
        const getField = this.getField;
        const foliosGuiasEnVehiculo = this.foliosGuiasEnVehiculo(this.props);
        const avisoEntregasNoLiberadas = this.avisoEntregasNoLiberadas(this.props);
        const Chofer = getField(selectores.ChoferZE);
        const Vehiculo = getField(selectores.VehiculoZE);

        return (
            <div>
                <kea.Title titulo="Carga de zona extendida" onRegresar={() => history.go("../")} >
                    <ImprimirAcusesButton onClick={this.onGenerarAcuses} />
                    <ImprimirManifiesto onClick={this.onImprimirManifiesto} />
                </kea.Title>
                {kea.autogrid(6, [
                    <kea.Number label="Folio:" value={value.Folio} readonly />
                ])}

                <div className="row">
                    <div className="col-md-6">
                        <GuiasEnOtraCarga foliosGuias={foliosGuiasEnVehiculo} onVerGuiasEnVehículo={this.onVerGuiasEnVehículo} />
                    </div>
                    <div className="col-md-6">
                        <AvisoEntregasNoLiberadas aviso={avisoEntregasNoLiberadas} />
                    </div>
                </div>

                {
                    kea.autogrid(6, [
                        <Chofer field="IdChoferZE" label="Chofer" readonly />
                    ])
                }
                {
                    kea.autogrid(6, [
                        <Lector idCarga={value.IdRegistro} />
                        /*
                        ,
                        <div style={{ marginTop: "2%" }}>
                            <kea.Button style="primary" onClick={this.onSeleccionarGuias} children="Seleccionar guías" />
                        </div>
                        */
                    ])
                }
                {
                    !nuevo &&
                    <EstatusCargaDescarga value={value.IdRegistro} />
                }
                {this.modals.component}
            </div >);
    }
}

interface PropsComp {
    foliosGuias: string[];
    onVerGuiasEnVehículo: () => void;
}

class GuiasEnOtraCargaNoRX extends React.PureComponent<PropsComp> {

    foliosguias = (x: PropsComp) => x.foliosGuias || [];
    hayGuias = createSelectorRx(this.foliosguias, foliosguias => foliosguias.length > 0);

    render() {
        const hayGuias = this.hayGuias(this.props);
        const foliosguias = this.foliosguias(this.props);
        return (
            <div>
                {
                    hayGuias ?
                        <div className="alert alert-warning">
                            <h3>Guías en vehículo</h3>
                            <br />
                            El vehículo asignado cuenta con guías que fueron cargadas previamente en otro movimiento de carga de zona extendida
                            <hr />
                            Las guías son:
                            <br />
                            {foliosguias.map((x, i) => (i === foliosguias.length - 1) ? x + "." : x + ", ")}
                            <hr />
                            <div className="btn-group">
                                <VerGuiasIncluidasButton onClick={this.props.onVerGuiasEnVehículo} />
                            </div>
                        </div> : null
                }
            </div>
        )
    }
}

const GuiasEnOtraCarga = componentToRx(GuiasEnOtraCargaNoRX);

interface PropsAviso {
    aviso: models.AvisoEntregaNoLiberada;
}

class AvisoEntregasNoLiberadasNoRX extends React.PureComponent<PropsAviso> {

    aviso = (x: PropsAviso) => x.aviso;
    hayAviso = createSelectorRx(this.aviso, aviso => aviso != null);

    render() {
        const hayAviso = this.hayAviso(this.props);
        const aviso = this.aviso(this.props);
        return (
            <div>
                {
                    hayAviso ?
                        <div className="alert alert-warning">
                            <h3>Entregas pendientes de liberar</h3>
                            <br />
                            Tiene entregas de zona extendida realizadas que aun no han sido liberadas
                            <hr />
                            Cantidad de entregas: {aviso.CantidadEntregasNoLiberadas}
                            <br />
                            Cantidad de acuses firmados: {aviso.CantidadDeAcuses}
                            <br />
                            Total a liberar por entregas de flete por cobrar: {kea.formatCurrency(aviso.MontoFXCEntregasNoLiberadas)}
                            <br />
                            <br />
                        </div> : null
                }
            </div>
        )
    }
}

const AvisoEntregasNoLiberadas = componentToRx(AvisoEntregasNoLiberadasNoRX);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasze/edit/form.tsx